import {
  Box,
  Switch,
  Flex,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react';
import { CustomSchedule } from '@/ui/schedule/custom';
import { Schedule as DefaultSchedule } from '@/ui/schedule/default';
import { useState, useEffect } from 'react';
import { useField } from 'formik';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { useSelector, useDispatch } from 'react-redux';
import { selectMeForUpdate } from '@/store/me';
import { Field, ErrorMessage } from 'formik';
import { isInvalidField } from '@/lib/util';
import { editMe } from '@/store/me/actions';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { KText } from '@/ui-library/components/text';
import { TimeZoneSelectorV1 } from '@/components/formBuilder/formFields/DateField/components/TimeZoneSelectorV1';

const shouldShowDefaultSchedule = (schedules = {}) => {
  return Object.values(schedules)?.every((schedule, _i, arr) => {
    return schedule?.start === arr[0]?.start && schedule?.end === arr[0]?.end;
  });
};

export const Schedule = ({ isNew = false, fieldName }) => {
  const { track } = useMixpanel();
  const dispatch = useDispatch();
  const { tFlowTimeZone } = useFlags();
  const { isLoading } = useSelector(selectMeForUpdate);
  const [_field, meta, helpers] = useField(fieldName); // eslint-disable-line
  const { setValue, setError } = helpers;
  const { initialValue = {} } = meta;

  useEffect(() => {
    dispatch(editMe());
  }, [dispatch]);

  const [isCustomSchedule, setIsCustomSchedule] = useState(
    () => !shouldShowDefaultSchedule(initialValue)
  );

  const scheduleChange = (schedule) => {
    const hasSchedule = Object.keys(schedule);
    if (hasSchedule?.length === 0) {
      setError(true);
      setValue('');
    }
    setValue(schedule);
  };

  return (
    <Box>
      {tFlowTimeZone && (
        <Field name="time_zone">
          {({ field, form, meta }) => (
            <FormControl isInvalid={isInvalidField(form, meta)} isRequired>
              <TimeZoneSelectorV1
                value={field?.value ? { key: field.value } : null}
                onChange={(selectedTimeZone) => {
                  form.setFieldValue('time_zone', selectedTimeZone.key);
                }}
                inputProps={{
                  isDisabled: isLoading,
                }}
              />
              <FormErrorMessage>
                <ErrorMessage name="time_zone" />
              </FormErrorMessage>
            </FormControl>
          )}
        </Field>
      )}

      {!isCustomSchedule && (
        <Box mt="12px">
          <DefaultSchedule
            isNew={isNew}
            schedule={initialValue}
            onChange={scheduleChange}
          />
        </Box>
      )}

      <Flex mt="16px">
        <Switch
          isChecked={isCustomSchedule}
          className={`ats-switch-toogle ${isCustomSchedule ? 'active' : ''}`}
          colorScheme="ats-primary"
          onChange={() => {
            setIsCustomSchedule((prev) => !prev);
            track({
              module: 'mco',
              data: {
                'user-event': 'click',
                'user-action': 'mco-change-to-custom-schedule',
              },
            });
          }}
        />
        <KText variant="muted" color="primary-700" size="sm-semi-bold" ml="8px">
          Custom schedule
        </KText>
      </Flex>

      {isCustomSchedule && (
        <Box mt="16px">
          <CustomSchedule
            isNew={isNew}
            schedule={initialValue}
            onChange={scheduleChange}
          />
        </Box>
      )}
    </Box>
  );
};
